import { useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { BsLayoutThreeColumns } from "react-icons/bs"
import { Esquema } from "../../lib/esquemas/tablas"
import { useDispatch, useSelector } from "react-redux"
import { modificarEsquema } from '../../redux/actions/esquemaTablas'
import { ReactSortable } from "react-sortablejs";


const PersonalizarColumnas = (props) => {
    const {
        screen
    } = props

    const [ openModal, setOpenModal ] = useState(false)
    const session = useSelector(state => state.miusuario)
    const esquema_tablas = useSelector(state => state.esquema_tablas)
    const dispatch = useDispatch()

    const handleClose = () => {
        setOpenModal(false)
    }

    const handleChange = (e, column) => {
        const instancia_esquema = JSON.parse( JSON.stringify(esquema_tablas) )
        const i = instancia_esquema[screen].findIndex(e => e.key === column.key)
        if(i > -1){
            instancia_esquema[screen][i].active = e.target.checked
        } else {
            instancia_esquema[screen].push({
                ...column,
                active: e.target.checked
            })
        }
        return dispatch(modificarEsquema(instancia_esquema, session.tokenSession))
    }

    const grupos = []

    for ( const item of Esquema.ORDENES ){
        const {
            group
        } = item
        const i = grupos.findIndex(g => g.titulo === group)
        if(i > -1){
            grupos[i].items.push(item)
        } else {
            grupos.push({
                titulo: group,
                items: [ item ]
            })
        }
    }

    return <div>
        <Button size="sm" className='w-100' variant='light' onClick={() => setOpenModal(true)} ><BsLayoutThreeColumns /> COLUMNAS</Button>
        <Modal show={openModal} size="xl" onHide={handleClose}
        centered
        >
        <Modal.Header closeButton className="pb-0">
        <div>
          <Modal.Title>Personaliza las columnas que deseas visualizar</Modal.Title>
          <p>Puedes mover los elementos para cambiar su posicion</p>
          </div>
        </Modal.Header>
        <Modal.Body>
            <Row className="d-flex justify-content-center">
                {
                    grupos.map((g, grupoIndex) => (
                        <div id={`sortable-container-${grupoIndex}`} key={`grupo-${grupoIndex}`} className="mx-1">
                        <h6 className="text-uppercase font-weight-bold pl-3"
                        style={{fontSize: 14}}
                        >{g.titulo}</h6>
                        <ReactSortable list={g.items} setList={(d) => console.log(d)}>
                          {g.items.map((column, i) => {
                              let checked = false;
                            const pos = esquema_tablas[screen].findIndex(e => e.key === column.key);
                            if (pos > -1) checked = esquema_tablas[screen][pos].active === true ? true : false;
                    
                            return (
                                <Col key={`column-${i}`} className="mb-3">
                                <Form.Group className="mb-0" controlId={column.key}>
                                  <div className="handle hover d-flex bg-light font align-items-center border px-2 shadow-sm"
                                  style={{fontSize:15}}>
                                    <i className="fa-solid fa-arrows-up-down-left-right mr-1  text-secondary"></i>
                                    <Form.Check 
                                      type="switch" 
                                      defaultChecked={checked} 
                                      name={column.key} 
                                      label={column.label} 
                                      onChange={(e) => handleChange(e, column)} />
                                  </div>
                                </Form.Group>
                              </Col>
                            );
                        })}
                        </ReactSortable>
                        </div>
                      ))
                
                }
            </Row>
            <div className="d-flex justify-content-end">
            <Button className="btn btn-primary mt-3">Guardar configuración</Button>
            </div>
        </Modal.Body>
        
      </Modal>
    </div>
}

export default PersonalizarColumnas